/**
 * Split on `**...**` pairs for safe inline rendering (no HTML from the model).
 * Unbalanced `**` is folded into the preceding plain segment (trailing `**` stays literal).
 */
export function parseInlineBoldSegments(text) {
    if (!text) {
        return [{ bold: false, text: '' }];
    }
    if (!text.includes('**')) {
        return [{ bold: false, text }];
    }
    const raw = text.split('**');
    while (raw.length % 2 === 0 && raw.length > 0) {
        const tail = raw.pop() ?? '';
        const i = raw.length - 1;
        if (i < 0) {
            return [{ bold: false, text: '**' + tail }];
        }
        raw[i] = (raw[i] ?? '') + '**' + tail;
    }
    return raw.map((segment, index) => ({
        bold: index % 2 === 1,
        text: segment
    }));
}
